export default {
	text: "Goal created by {changedBy}",
};
